import { Component, OnInit, HostListener } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { UiButtonComponent } from '../../button/button.component';

import { AppService } from '../../../core/app.service';
import { Router } from "@angular/router";
import { AuthService } from '../../../services/auth/auth.service';

@Component({
    templateUrl: "./profilemenu.component.html",
    styleUrls: ["./profilemenu.component.scss"],
    imports: [
        CommonModule,
        RouterModule,
        MatIconModule,
        UiButtonComponent
    ],
    standalone: true,
    selector: "ProfileMenu"
})
export class ProfileMenu implements OnInit {

    public nom: string = "";
    public prenoms: string = "";
    public profil: string = "";
    public isClicked = false;

    public menuItems: Array<{
        label: string;
        icon?: string;
        route?: string;
        action?: string;
        badge?: string;
        danger?: boolean;
    }> = [
        { label: 'Mon profil',   icon: 'person_outline', route: '/app/profile' },
        { label: 'Sécurité',     icon: 'shield',         route: '/app/security' },
        { label: 'Déconnexion',  icon: 'logout',         action: 'logout', danger: true }
    ];

    constructor(
        private router: Router,
        private authService: AuthService,
        private appService: AppService
    ) {}

    ngOnInit(): void {
        this.nom     = this.appService.getLastName();
        this.prenoms = this.appService.getFirstName();
        this.profil  = this.appService.getProfile();
    }

    /** Initiales calculées à partir du nom et prénom */
    get initials(): string {
        const first = this.nom?.charAt(0)?.toUpperCase() ?? '';
        const last  = this.prenoms?.charAt(0)?.toUpperCase() ?? '';
        return first + last || '?';
    }

    onClickProfile(): void {
        this.isClicked = !this.isClicked;
    }

    /** Ferme le dropdown si le clic est à l'extérieur du composant */
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        if (!target.closest('ProfileMenu')) {
            this.isClicked = false;
        }
    }

    logoutProfile(): void {
        this.isClicked = false;
        this.authService.logout();
    }
}